export class QuickLinkTemplateValidationFields {
  static NameLinkTemplate = {
    OriginalWebURL: 'nameLinkTemplate-originalWebURL',
    LinkAlias: 'nameLinkTemplate-linkAlias',
    Title: 'nameLinkTemplate-linkTitle',
  };

  static AnalyticTags = {
    Campaign: 'analyticsTags-campaign',
    Feature: 'analyticsTags-feature',
    Channel: 'analyticsTags-channel',
    Tags: 'analyticsTags-tags',
  };

  static SocialMediaTags = {
    Title: 'socialMediaTags-title',
    Description: 'socialMediaTags-description',
    ImageUrl: 'socialMediaTags-imageUrl',
  };

  static LinkData = 'linkData-';

  static Redirects = 'redirects-';
}
